enum IWaveStat {
  SCORE = 'score',
  PROPENSITY = 'propensityScore',
  AFFINITY = 'affinityScore',
  CAPACITY = 'capacityScore',
  PLANNED_GIVING = 'plannedGivingScore',
  RFM = 'rfmScore',
}

export default IWaveStat;
